<template>
  <div class="header">
    <i class="iconfont" @click="back()">&#xe60a;</i>
    <span>{{title}}</span>
    <i class="iconfont" v-if="!atGame">&#xe609;</i>
    <i class="iconfont" v-else @click="searchInput">&#xe724;</i>
  </div>
</template>

<script>
  import {mapState,mapActions} from 'vuex';

  export default {
    name: "AppHeader",
    data(){
      return{
        atGame:false
      }
    },
    mounted(){
      if(this.$route.name==='game') this.atGame = true;
      this['system/setTitle'](this.$route.meta.title);
    },
    methods:{
      ...mapActions(['system/setTitle','system/setSearch']),
      back(){
        if(this.$route.meta.referral) this.$router.push('/user');
        else this.$router.back();
      },
      searchInput(){
        this['system/setSearch'](!this.search);
      }
    },
    watch:{
      $route:function (to) {
        if(to.name==='game'){
          this.atGame = true;
        }else{
          this.atGame = false;
        }
      }
    },
    computed:{
      ...mapState({
        title: state => state.system.title,
        search: state => state.system.search
      })
    }
  }
</script>

<style scoped lang="scss">
  .header {
    width: 100%;
    height: 110px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 28px 0 22px;
    background: #222a33;
    color: #fff;
    font-size: 30px;
    position: fixed;
    top: 0;
    z-index: 1001;

    i {
      color: #fff;
      font-size: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AppHeader/AppHeader.vue